import { InstrumentTypeCode } from "@/lib/interfaces and Enums/ENUMInstrumentTypeCode";
import { TNotation } from "@/lib/interfaces and Enums/TYPENotations";
import { create } from "zustand";

export interface IBlockAssigned {
  id: number;
  direction: string;
  notionalLeg1: number;
  notionalLeg2: number;
  openClose: string;
  instrumentType: InstrumentTypeCode;
  securityType?: string;
  securityName: string;
  isin?: string;
  effectiveDate: string; //2025-05-09
  extStructureId: number | null;
  dateCreated: string | null;
  dV01: number;
  creditSpreadRisk: number;
  newIssue: boolean;
  unwind: "NPV" | "Recoupon" | null;
  coupon: number; // LQC-2153: also the FRN Current Coupon
  referenceIndex?: string; // LQC-2153: FRN only
  quotedMargin?: number; // LQC-2153: FRN only
  indicativeMid: number | null;
  indicativeNPV: number | null;
  currency: string;
  allocations: any[];
  notation: TNotation;
  esid?: string;
}

export interface ItradeBlockData {
  esid: string;
  blocks: IBlockAssigned[];
}

type State = {
  tradeBlockData: ItradeBlockData[];
};

type Action = {
  // eslint-disable-next-line no-unused-vars
  updateTradeBlockData: (tradeBlockData: State["tradeBlockData"]) => void;
};

const tradeBlockDataStore = create<State & Action>((set) => ({
  tradeBlockData: [],
  updateTradeBlockData: (
    incomingData: {
      esid: string;
      blocks: IBlockAssigned[];
    }[],
  ) => {
    set(() => ({
      tradeBlockData: incomingData,
    }));
  },
}));

export default tradeBlockDataStore;
